var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "default-layout",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "login",
      attrs: {
        title: _vm.getPageTitle(),
        "sub-title": _vm.t("LoginPage.subTitle"),
        "logo-src": _vm.displayLogo,
        "logo-alt": _vm.displayThemeName,
      },
    },
    [
      _c(
        "sm-form",
        {
          ref: "form",
          attrs: { id: "login-form", autocomplete: "on" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "fieldset",
            [
              _vm.getStage === "Password"
                ? _c(
                    "div",
                    { staticClass: "user-entered-email-container" },
                    [
                      _c(
                        "sm-button",
                        {
                          attrs: {
                            "aria-label": "Close",
                            shape: "square",
                            type: "text",
                          },
                          on: { click: _vm.navigateFromPasswordToEmail },
                        },
                        [_c("sm-icon", { attrs: { name: "arrow-go-back" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-entered-email" }, [
                        _c("h6", { attrs: { title: _vm.user.email } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.user.email) +
                              "\n          "
                          ),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.getStage === "Email"
                ? _c(
                    "div",
                    { attrs: { disabled: _vm.loading } },
                    [
                      _c("sm-input", {
                        key: "email",
                        attrs: {
                          id: "login-email",
                          type: "email",
                          name: "username",
                          rules: "required|email",
                          label: _vm.t("LoginPage.emailLabel"),
                          placeholder: _vm.t("LoginPage.emailPlaceholder"),
                          autofocus: "",
                          "auto-complete": "username",
                        },
                        model: {
                          value: _vm.user.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "email", $$v)
                          },
                          expression: "user.email",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "login-remember-container" },
                        [
                          _c("sm-checkbox", {
                            attrs: {
                              id: "login-remember",
                              disabled: _vm.loading,
                              name: "genres",
                              label: _vm.t("LoginPage.rememberEmailLabel"),
                              "selected-value": "classical",
                            },
                            model: {
                              value: _vm.rememberEmail,
                              callback: function ($$v) {
                                _vm.rememberEmail = $$v
                              },
                              expression: "rememberEmail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass: "password-stage",
                      attrs: {
                        "data-heap-redact-attributes": "value",
                        "data-heap-redact-text": "true",
                        disabled: _vm.loading,
                      },
                    },
                    [
                      _c("input", {
                        staticClass: "sr-only",
                        attrs: { name: "username", autocomplete: "username" },
                        domProps: { value: _vm.user.email },
                      }),
                      _vm._v(" "),
                      _c("sm-input", {
                        key: "password",
                        staticClass: "login-password",
                        attrs: {
                          "data-heap-redact-text": "true",
                          type: _vm.showPassword ? "text" : "password",
                          name: "password",
                          label: _vm.t("LoginPage.passwordLabel"),
                          rules: "required",
                          "auto-complete": "current-password",
                          placeholder: _vm.t("LoginPage.passwordPlaceholder"),
                          autofocus: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "suffix",
                            fn: function () {
                              return [
                                _c(
                                  "sm-button",
                                  {
                                    attrs: { type: "tertiary" },
                                    on: { click: _vm.toggleShowHidePassword },
                                  },
                                  [
                                    _c("sm-icon", {
                                      class: [
                                        "eye-icon",
                                        { "hide-password": _vm.showPassword },
                                      ],
                                      attrs: {
                                        name: _vm.showPassword
                                          ? "action-hide"
                                          : "action-show",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.user.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "password", $$v)
                          },
                          expression: "user.password",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "forgot-password" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "ResetPasswordPage" } } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.t("LoginPage.resetPasswordLink")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "sm-button",
                    {
                      attrs: {
                        id: "login-submit",
                        "native-type": "submit",
                        type: "primary",
                        loading: _vm.loading,
                      },
                    },
                    [
                      _vm.getStage === "Email"
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.t("LoginPage.nextButton")) +
                                "\n          "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.t("LoginPage.loginButton")) +
                                "\n          "
                            ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.getStage === "Email" && _vm.showLoginPasskeyButton
                    ? _c(
                        "div",
                        { attrs: { "sm-data-test": "login-passkey-button" } },
                        [
                          _c("div", { staticClass: "divider-outer" }, [
                            _c("div", { staticClass: "divider-head" }, [
                              _c("div", { staticClass: "passkey-divider" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "passkey-divider-inner" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "passkey-divider-text" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.t("LoginPage.passkeyDivider")
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "passkey-divider" }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "sm-button",
                            {
                              attrs: {
                                id: "login-passkey",
                                type: "secondary",
                                loading: _vm.loading,
                              },
                              on: { click: _vm.handleLoginPasskey },
                            },
                            [
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.t("LoginPage.loginPasskeyButton")
                                    ) +
                                    "\n            "
                                ),
                              ],
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.errorMessage
                ? _c("sm-help-card", {
                    attrs: { type: "warning" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.errorMessage) +
                                  "\n        "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      4086182172
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              (_vm.localisedHelpUrl || _vm.loginHelpUrl) &&
              _vm.getStage === "Password"
                ? _c("div", { staticClass: "login-help" }, [
                    _c(
                      "a",
                      {
                        staticClass: "el-button el-button--text",
                        attrs: {
                          href: _vm.localisedHelpUrl || _vm.loginHelpUrl,
                          target: "_blank",
                        },
                      },
                      [
                        _c("sm-icon", {
                          attrs: { name: "utility-information" },
                        }),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("LoginPage.troubleLoggingInLink")) +
                            "\n        "
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }